import * as $ from 'jquery';

/*
 * Force scrollbar to bottom of list
 */
angular.module('posApp').directive('forceScroll', ($timeout) => ({
  restrict: 'A',

  link: function (scope, elm, attrs) {
    $timeout(() => {
      $(elm).scrollTop(elm[0].scrollHeight);
    }, 0);

    //Resize when window resize occurs
    scope.$root.$on('forceScroll', (scope) => {
      $timeout(() => {
        $(elm).scrollTop(elm[0].scrollHeight);
      }, 0);
    });
  },
}));
